import type { PersonaTopAd } from "../types/personas.types";

export interface PersonaAdMedia {
  type: "image" | "video";
  thumbnailUrl: string;
  assetUrl: string;
}

const THUMBNAIL_EXTENSION = ".png";

/**
 * Ad thumbnails live alongside assets under `/thumbnails/` as a `.png` — same
 * convention as the overview topic examples (BQ `adge_url` is the canonical asset URL).
 */
export function resolvePersonaAdMedia(ad: PersonaTopAd): PersonaAdMedia {
  const type: PersonaAdMedia["type"] = ad.adgeUrl.toLowerCase().endsWith(".mp4") ? "video" : "image";
  const thumbnailUrl = ad.adgeUrl.replace("/assets/", "/thumbnails/").replace(/\.[^./]+$/, THUMBNAIL_EXTENSION);
  return { type, thumbnailUrl, assetUrl: ad.adgeUrl };
}
